/**
 * Given an array of collections return the sum of base entries + bonus entries
 * @param  {Array} collections parameter for collection data
 * @return {Number} 0 or the sum of base entries + bonus entries for each collection
 */
export const countMonopolyDrawingEntries = collections => {
    return collections.reduce(
        (total, collection) =>
            total + parseInt(collection.base_entries, 10) + parseInt(collection.bonus_entries, 10),
        0
    );

};
